// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 3136) return "static/chunks/3136.2811fea5134de182.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"6008":"c9e7eb2a86abbacd","7244":"7b2c15f87247c747","8267":"f62536de41b7b40a","9256":"32f93164b868db48"}[chunkId] + ".js";
};